import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS, NumberUtils } from '@pk/powerkioskutils';

import { RfqSessionBid, RfqSessionStat } from '../models';

@Pipe({
	name: 'convertBidUnits',
	standalone: false,
})
export class ConvertBidUnitsPipe implements PipeTransform {
	transform(bid: number | RfqSessionBid | RfqSessionStat, units: string, serviceTypeId = null): number {
		const amount =
			bid instanceof RfqSessionBid // bid
				? bid.displayRate
				: bid instanceof RfqSessionStat // stat
					? bid.bestBid
					: bid; // number

		if (serviceTypeId) {
			if (serviceTypeId === CONSTANTS.serviceTypes.naturalGas.serviceTypeId) {
				return NumberUtils.rateToUnits(amount, 'dth');
			} else if (serviceTypeId === CONSTANTS.serviceTypes.electricity.serviceTypeId) {
				return NumberUtils.rateToUnits(amount, 'mwh');
			}
		}

		return NumberUtils.rateToUnits(amount, units.split('/')[1]);
	}
}
